import { combineEpics } from 'redux-observable';

import updateCartCurrency from './updateCartCurrency';
import flushItemDeletionQueue from './flushItemDeletionQueue';

export default combineEpics(updateCartCurrency, flushItemDeletionQueue);
